import { Link } from "react-router-dom";
import { BrandLogo } from "@/components/shared/common/BrandLogo";

export function LandingFooter() {
  return (
    <footer style={{ background: "#0d0d0d" }} className="py-12">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <Link to="/">
            <BrandLogo variant="dark" imgClassName="h-16 w-auto" />
          </Link>

          <nav className="flex flex-wrap justify-center gap-6">
            <a
              href="#features"
              className="text-sm text-white/40 hover:text-white/70 transition-colors"
            >
              Features
            </a>
            <a
              href="#pricing"
              className="text-sm text-white/40 hover:text-white/70 transition-colors"
            >
              Pricing
            </a>
            <Link
              to="/login"
              className="text-sm text-white/40 hover:text-white/70 transition-colors"
            >
              Sign In
            </Link>
            <Link
              to="/signup"
              className="text-sm text-white/40 hover:text-white/70 transition-colors"
            >
              Get Started
            </Link>
          </nav>

          <p className="text-xs text-white/30">
            © {new Date().getFullYear()} PipeTalent AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
